module.exports = __webpack_public_path__ + "static/1-7d8c2f4d7be0b934774d73527f656f9e.png";